var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$store.state.filter ? 'activated' : 'deactivated',attrs:{"id":"header_toggle_filter"}},[_c('b-btn',{staticClass:"header_button button_white_blue",on:{"click":function($event){return _vm.$store.dispatch('toggleFilter')}}},[_vm._v("\n        "+_vm._s(_vm.$t("header.search.toggleFilter"))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }